import * as React from 'react';
import { Router } from 'react-router-dom';
import type { History } from 'history';

interface HistoryRouterProps {
    history: History;
    basename?: string;
    children?: React.ReactNode;
}

/**
 * Router that renders using an externally provided history instance.
 * Replaces `redux-first-history/rr6`'s HistoryRouter, which depends on the
 * `unstable_HistoryRouter` export removed in react-router v7.
 */
export const HistoryRouter = ({ history, basename, children }: HistoryRouterProps) => {
    const [state, setState] = React.useState({
        action: history.action,
        location: history.location,
    });

    React.useLayoutEffect(() => history.listen(setState), [history]);

    return (
        <Router
            basename={basename}
            location={state.location}
            navigationType={state.action}
            navigator={history}
        >
            {children}
        </Router>
    );
};

export default HistoryRouter;
